











import {Component, Vue} from 'vue-property-decorator';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

@Component({})
export default class App extends Vue {
    locale = zhCN
}
